import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import type { CtaBlockResolved } from './types';
import { CtaActionButton } from '@/components/CtaActionButton';
import { headingTag } from '@/lib/render/headingTag';
import { useRenderContext } from '@/lib/render/RenderContextProvider';
import { RichText } from '@/lib/render/RichText';
import { Text } from '@/lib/render/Text';

export function CtaBlockComponent({
  resolved,
}: {
  resolved: CtaBlockResolved;
}) {
  const { substitutePlaceholders: sub } = useRenderContext();
  const heading = headingTag(resolved.titlePower ?? '2', resolved.visualOnly);
  const actions = resolved.actions ?? [];

  return (
    <section className="pt-4 text-center">
      {resolved.title && (
        <Text
          as={heading.as}
          field="title"
          className={classNames(heading.className, 'mb-4')}
        >
          {resolved.title}
        </Text>
      )}
      {resolved.body && (
        <div className="mb-8">
          <RichText nodes={resolved.body} />
        </div>
      )}
      {actions.length > 0 && (
        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          {actions.map((action, i) => (
            <CtaActionButton
              key={i}
              action={action}
              fallbackPhone={resolved.phone}
              fallbackMatelsoPhoneLabel={resolved.matelsoPhoneLabel}
              sub={sub}
            />
          ))}
        </div>
      )}
    </section>
  );
}
